// Chamado: o servidor do DadosPJ abre o caso na Área do Cliente (POST /suporte-ia/chamado/); o navegador nunca
// fala com a Área do Cliente nem vê o token.
import { authFetch } from "../api";
import { API } from "./conversas";

export const TEXTOS_CHAMADO = {
  abrindo: "Calma aí, vou chamar a equipe de suporte da New Córtex...",
  pronto: "Pronto, a New Córtex já foi avisada! A equipe responde pela Área do Cliente.",
  repetido: "Esse caso já estava aberto; segue o mesmo número.",
  falhou: "Não consegui falar com a New Córtex agora. Pode tentar de novo daqui a pouco?",
  desligado: "Não consegui resolver por aqui. Fale com a New Córtex pela Área do Cliente.",
};

/** Chave de idempotência: a mesma ao tentar de novo, outra a cada pedido novo (^[A-Za-z0-9_-]{8,100}$). */
export const novaChave = () =>
  (window.crypto?.randomUUID?.() ?? `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`).replace(/[^A-Za-z0-9_-]/g, "");

/** Card do caso aberto: sem número não há card; o link só vale se for http(s). */
export function lerCard(d) {
  const numero = typeof d?.numero === "string" || typeof d?.numero === "number" ? String(d.numero).replace(/^#/, "") : "";
  if (!numero) return null;
  const url = typeof d.url === "string" && /^https?:\/\//.test(d.url) ? d.url : "";
  return { codigo: numero, titulo: typeof d.titulo === "string" ? d.titulo : "", href: url };
}

/** Pede ao servidor para abrir o caso. Devolve {card, repetido}; erro com mensagem pronta para a tela. */
export async function abrirChamado({ conversa, chave, historico, resumo, pagina }) {
  const r = await authFetch(`${API}/chamado/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ conversa, chave, historico, resumo, pagina }),
  }).catch(() => null);
  const d = await r?.json?.().catch(() => null);
  const card = r?.ok ? lerCard(d) : null;
  if (!card) throw new Error(typeof d?.erro === "string" ? d.erro : TEXTOS_CHAMADO.falhou);
  return { card, repetido: d.repetido === true };
}

